'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { motion, type Variants } from 'motion/react';
import { getVariants, useAnimateIconContext, IconWrapper, type IconProps } from '@/components/animate-ui/icons/icon';
type SendProps = IconProps<keyof typeof animations>;
const animations = {
  default: {
    group: {
      initial: {
        scale: 1,
        x: 0,
        y: 0
      },
      animate: {
        scale: [1, 0.8, 1, 1, 1],
        x: [0, '-10%', '100%', '-125%', 0],
        y: [0, '10%', '-100%', '125%', 0],
        transition: {
          default: {
            ease: 'easeInOut',
            duration: 1.2
          },
          x: {
            ease: 'easeInOut',
            duration: 1.2,
            times: [0, 0.25, 0.5, 0.5, 1]
          },
          y: {
            ease: 'easeInOut',
            duration: 1.2,
            times: [0, 0.25, 0.5, 0.5, 1]
          }
        }
      }
    },
    path1: {},
    path2: {}
  } satisfies Record<string, Variants>
} as const;
function IconComponent(t0) {
  const $ = _c(15);
  let props;
  let size;
  if ($[0] !== t0) {
    ({
      size,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = size;
  } else {
    props = $[1];
    size = $[2];
  }
  const {
    controls
  } = useAnimateIconContext();
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getVariants(animations);
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const variants = t1;
  let t2;
  let t3;
  if ($[4] !== controls) {
    t2 = <motion.path d="M14.5,21.7c.1.3.4.4.7.3.1,0,.2-.2.3-.3L22,2.7c0-.3,0-.5-.3-.6-.1,0-.2,0-.3,0L2.3,8.5c-.3,0-.4.4-.3.6,0,.1.2.2.3.3l7.9,3.2c.5.2.9.6,1.1,1.1l3.2,7.9Z" variants={variants.path1} initial="initial" animate={controls} />;
    t3 = <motion.path d="M21.9,2.1l-10.9,10.9" variants={variants.path2} initial="initial" animate={controls} />;
    $[4] = controls;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  let t4;
  if ($[7] !== controls || $[8] !== t2 || $[9] !== t3) {
    t4 = <motion.g variants={variants.group} initial="initial" animate={controls}>{t2}{t3}</motion.g>;
    $[7] = controls;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== props || $[12] !== size || $[13] !== t4) {
    t5 = <motion.svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" {...props}>{t4}</motion.svg>;
    $[11] = props;
    $[12] = size;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}
function Send(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <IconWrapper icon={IconComponent} {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export { animations, Send, Send as SendIcon, type SendProps, type SendProps as SendIconProps };